import { AlertCircle, Home } from 'lucide-react';
import { Button } from '@client/components/ui/button';

interface MissingStepsErrorProps {
  policyType: string;
  onGoHome?: () => void;
}

export function MissingStepsError({ policyType, onGoHome }: MissingStepsErrorProps) {
  return (
    <div className="bg-primary-50 flex min-h-screen items-center justify-center">
      <div className="mx-auto max-w-md text-center">
        <div className="mb-4 flex justify-center">
          <AlertCircle className="h-12 w-12 text-amber-500" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-gray-900">Configuration Issue</h2>
        <p className="mb-4 text-gray-700">No application steps were found for this policy type.</p>
        <div className="mb-6 rounded-md bg-amber-50 p-4">
          <p className="text-sm text-amber-700">
            Policy Type: <span className="font-medium">{policyType}</span>
          </p>
        </div>
        <div className="flex justify-center">
          {onGoHome && (
            <Button
              onClick={onGoHome}
              className="flex items-center gap-2"
            >
              <Home className="h-4 w-4" />
              Go to Dashboard
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
